import React, { useEffect, useState } from "react";
import { Avatar, Button, Typography, Card, Empty, Spin } from "antd";
import ProfileHeader from "../../Proflie/ProfileHeader";
import { DoubleRightOutlined, ToTopOutlined } from "@ant-design/icons";
import { IoIosMore } from "react-icons/io";
import Meta from "antd/es/card/Meta";
import { BsRobot } from "react-icons/bs";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { MdFavoriteBorder } from "react-icons/md";
import ExploreAgentCard from "../../Card/ExploreAgentCard";
import { BiDownArrow } from "react-icons/bi";
import { TiArrowSortedDown } from "react-icons/ti";
import { getUserOrg } from "../../../api/user";
import { getAllPublicAssistants } from "../../../api/publicAssistant";
import { getUserRole } from "../../../Utility/service";
const AllExploreAgents = ({
  assistantsByCategory,
  chatWithAssistant,
  addFavoriteAssistant,
  userId,
  handleLoadMore,
  searchQuery,
  selectAssistantType,
  handleCardClick,
  theme,
  featuredAssistants,
  loading,
  favoriteAssistant,
  setRefresh,
  setFavoriteAssistant,
  HeaderContentChildren,
  enablePersonalize = false,
}) => {

  const role = getUserRole();
  const { Title } = Typography;
  const [userOrgId, setUserOrgId] = useState(null);
  useEffect(() => {
    const fetchUserOrg = async () => {
      if (userId) {
        const orgId = await getUserOrg(userId);
        setUserOrgId(orgId);
      } else {
        console.error("User ID is not provided");
      }
    };

    fetchUserOrg();
  }, [userId]);
  return (
    <Spin spinning={loading}>
      <ProfileHeader
        title="All Agents"
        subHeading="Explore all the agents available on our platform publicaly created by you or the CollabAI Team"
      />
      {HeaderContentChildren}
      <div className="mt-3">
        {featuredAssistants?.assistants?.length === 0 &&
          assistantsByCategory?.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          !loading && (
            <Title level={5}>
              {featuredAssistants?.assistants?.length
                ? "👑Featured Agents"
                : ""}
            </Title>
          )
        )}
      </div>

      <div className="assistant-container mt-3">
        {featuredAssistants?.assistants?.map((assistant) => (
          <>
            <ExploreAgentCard
              agent={assistant}
              chatWithAssistant={chatWithAssistant}
              addFavoriteAssistant={addFavoriteAssistant}
              userId={userId}
              handleCardClick={handleCardClick}
              favoriteAssistantData={favoriteAssistant}
              setRefresh={setRefresh}
              setFavoriteAssistant={setFavoriteAssistant}
              enablePersonalize={enablePersonalize}
            // favoriteAssistant={true}
            />
          </>
        ))}
      </div>
      <div className="load-more-container">
        {featuredAssistants?.assistants?.length > 0 &&
          featuredAssistants?.assistants?.length !==
          featuredAssistants?.totalAssistantCount && (
            <>
              <div className="load-more-button">
                <Button
                  size="small"
                  icon={<TiArrowSortedDown />}
                  onClick={() => handleLoadMore({ categoryName: "featured" })}
                >
                  Load More{" "}
                </Button>
              </div>
              <hr
                style={{
                  borderColor: "hsl(0, 0%, 80%)",
                  marginTop: "24px",
                }}
              />
            </>
          )}
      </div>
      <div>
        {assistantsByCategory?.map((category, i) => {
          const filteredAssistants =
            category?.categoryInfo?.assistants?.filter((assistant) => {
              const matchesOrg = assistant.orgId === userOrgId;
              const isAdmin =
                assistant.isAdminAgent === true &&
                (!assistant.industryTypes ||
                  assistant.industryTypes.length === 0 ||
                  (assistant.industryTypes.length === 1 && assistant.industryTypes[0] === "null"));


              if (role === "user") {
                return isAdmin;
              }

              return matchesOrg || isAdmin;
            }) || [];



          return (
            <div key={category.categoryName}>
              {filteredAssistants.length > 0 ? (
                <Title className="my-3" level={5}>
                  {category?.categoryName}
                </Title>
              ) : (
                (searchQuery?.trim() || selectAssistantType?.trim()) && (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )
              )}
              <div className="assistant-container">
                {filteredAssistants.map((assistant) => (
                  <ExploreAgentCard
                    key={assistant.id}
                    agent={assistant}
                    chatWithAssistant={chatWithAssistant}
                    addFavoriteAssistant={addFavoriteAssistant}
                    userId={userId}
                    handleCardClick={handleCardClick}
                    favoriteAssistantData={favoriteAssistant}
                    setRefresh={setRefresh}
                    setFavoriteAssistant={setFavoriteAssistant}
                    enablePersonalize={enablePersonalize}
                  />
                ))}
              </div>
              <div className="load-more-container mt-1">
                {filteredAssistants.length > 0 &&
                  filteredAssistants.length !== category.categoryInfo?.totalAssistantCount ? (
                  <>
                    <div className="load-more-button">
                      <Button
                        size="small"
                        icon={<TiArrowSortedDown />}
                        onClick={() => handleLoadMore(category)}
                      >
                        Load More
                      </Button>
                    </div>
                    <hr
                      style={{
                        borderColor: "hsl(0, 0%, 80%)",
                        marginTop: "24px",
                      }}
                    />
                  </>
                ) : null} {/* ✅ Corrected this */}
              </div>

            </div>
          )
        })}
        {assistantsByCategory?.assistants?.length === 0 && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
      <span className="text-center w-100 d-block">There is no more data</span>
    </Spin>
  );
};

export default AllExploreAgents;
